import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // إعادة تعيين رسالة الخطأ عند البدء
    try {
      const response = await axios.post("https://hub.ppte.sa/api/auth/login", {
        email,
        password,
      });
      const token = response.data?.data?.token;
      if (token) {
        Cookies.set("token", token, { expires: 7 }); // حفظ التوكن لمدة 7 أيام
        toast.success("تم تسجيل الدخول بنجاح");
        navigate("/dashboard"); // إعادة التوجيه للداشبورد
      } else {
        throw new Error("Invalid response");
      }
    } catch (err) {
      toast.error("بيانات الدخول غير صحيحة");
      setError("بيانات الدخول غير صحيحة");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r ">
      <div className="w-full max-w-md bg-white bg-opacity-80 backdrop-filter backdrop-blur-lg p-8 rounded-xl shadow-lg">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          تسجيل الدخول
        </h2>
        <form onSubmit={handleLogin}>
          {error && <p className="text-red-600 text-center mb-4">{error}</p>}
          <div className="mb-5">
            <label
              htmlFor="email"
              className="block text-gray-700 font-medium mb-2"
            >
              البريد الإلكتروني
            </label>
            <input
              type="email"
              id="email"
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="password"
              className="block text-gray-700 font-medium mb-2"
            >
              كلمة المرور
            </label>
            <input
              type="password"
              id="password"
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full p-3 bg-[#C8A04F] text-white font-semibold rounded-md transition-all duration-300 ${
              loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#C8A04F9b]"
            }`}
          >
            {loading ? "جار تسجيل الدخول..." : "تسجيل الدخول"}
          </button>
          <div className="mt-4 text-center">
            <span className="text-gray-700">ليس لديك حساب؟ </span>
            <Link
              to="/register"
              className="text-blue-600 hover:underline font-medium"
            >
              إنشاء حساب جديد
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
